export const formatJobNumber = (jobNumber: string | undefined): string => {
  if (!jobNumber) return "";
  return jobNumber.replace(/_/g, " ");
};
